// @module Tavano.TT_PaymentHoldOn.MessageOnHold
define('Tavano.TT_PaymentHoldOn.MessageOnHold.View'
,	[
	'tavano_tt_paymentholdon_messageonhold.tpl'
	,	'Backbone'
    ]
, function (
	tavano_tt_paymentholdon_messageonhold_tpl
	,	Backbone
)
{
    'use strict';

	// @class Tavano.TT_PaymentHoldOn.MessageOnHold.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavano_tt_paymentholdon_messageonhold_tpl

	,	initialize: function (options) {
			this.container = options.container;
			this.environment = this.container.getComponent('Environment');
			this.message = this.environment.getConfig('tavano.onHoldMessage');
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Tavano.TT_PaymentHoldOn.MessageOnHold.View.Context
	,	getContext: function getContext()
		{
			//@class Tavano.TT_PaymentHoldOn.MessageOnHold.View.Context
			this.message = this.message
			return {
				message: this.message
			};
		}
	});
});
